import React, { useState } from "react";
import styles from "./EnquiriesScreen.module.css";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import Dropdown from "../../components/Dropdown/Dropdown";
import IconAndName from "../../components/IconAndName/IconAndName";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import { IoAddCircleOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import SearchBar from "../../components/SearchBar/SearchBar";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import CopyRight from "../../components/CopyRight/CopyRight";
import { useNavigate } from "react-router-dom";

const EnquiriesScreen = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedActions, setSelectedActions] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);


  const navigate = useNavigate();
  const data = [
    {
      _id: "1",
      studentName: "John Jacob",
      subLabel: "29/05/25–30/05/25",
      status: "Toured",
      contact: "9894994009",
      lastFollowUp: "10/06/2025",
      nextFollowUp: "10/06/2025",
      source: "Staff",
      assignedTo: "Staff",
      dueDate: "01/05/2025",
    },
    {
      _id: "2",
      studentName: "John Jacob",
      subLabel: "29/05/25–30/05/25",
      status: "Toured",
      contact: "9894994949",
      lastFollowUp: "10/06/2025",
      nextFollowUp: "10/06/2025",
      source: "Staff",
      assignedTo: "Staff",
      dueDate: "01/05/2025",
    },
    {
      _id: "3",
      studentName: "John Jacob",
      subLabel: "29/05/25–30/05/25",
      status: "Toured",
      contact: "97387493843",
      lastFollowUp: "10/06/2025",
      nextFollowUp: "10/06/2025",
      source: "Staff",
      assignedTo: "Staff",
      dueDate: "01/05/2025",
    },
    {
      _id: "4",
      studentName: "John Jacob",
      subLabel: "29/05/25–30/05/25",
      status: "Toured",
      contact: "9849950050",
      lastFollowUp: "10/06/2025",
      nextFollowUp: "10/06/2025",
      source: "Staff",
      assignedTo: "Staff",
      dueDate: "01/05/2025",
    },
  ];

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        studentName: (
          <LogoWithName name={item.studentName} dateRange={item.subLabel} />
        ),
        status: item.status,
        contact: item.contact,
        lastFollowUp: item.lastFollowUp,
        nextFollowUp: item.nextFollowUp,
        source: item.source,
        assignedTo: item.assignedTo,
        dueDate: item.dueDate,
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            setSelectedIds(
              e.target.checked ? data.map((item) => item._id) : []
            );
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Student Name", accessor: "studentName" },
    { title: "Status", accessor: "status" },
    { title: "Primary Contact", accessor: "contact" },
    { title: "Last Follow up", accessor: "lastFollowUp" },
    { title: "Next Follow up", accessor: "nextFollowUp" },
    { title: "Source", accessor: "source" },
    { title: "Assigned To", accessor: "assignedTo" },
    { title: "Due date", accessor: "dueDate" },
  ];

  const handleArchiveClick = () => {
    navigate("/view-archived");
  };
  const handleAddClick = () => dispatch(openModal("addEnquiry"));

  return (
    <div className={styles.copyright}>
      <div className={styles.screen}>
        <div className={styles.contentWrapper}>
          <div className={styles.toolbarWrapper}>
            <CalendarInput
              label="Date"
              value={selectedDate}
              onChange={setSelectedDate}
              background="var(--Utility_Color1)"
              textColor="gray"
              iconColor="gray"
              placeholderColor="gray"
              borderRadius="25px"
              shadow={false}
            />
            <Dropdown
              label="Source"
              options={["Online", "Referral", "Walk-in"]}
              bgColor="Error_Color"
              onChange={setSelectedSource}
            />
            <button className={styles.archiveBtn} onClick={handleArchiveClick}>
              View Archived
            </button>
            <IconAndName
              icon={<IoAddCircleOutline size={16} />}
              title="Add Enquiry"
              onClick={handleAddClick}
              bgColor="Primary_Color"
            />
          </div>

          {/* Stats */}
          <div className={styles.rowWrapper}>
            <div className={styles.cardsWrapper}>
              <ResultAndCount
                label="Total Enquiries"
                count={0}
                bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
                textColor="Success_Color"
              />
              <ResultAndCount
                label="Total Conversions"
                count={0}
                bgColor="rgba(from var(--Primary_Color) r g b / 0.7)"
                textColor="Primary_Color"
              />
              <ResultAndCount
                label="Enquiries Created today"
                count={0}
                bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
                textColor="Error_Color"
              />
              <ResultAndCount
                label="Follow -UP Due Today"
                count={0}
                bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
                textColor="Text_Color"
              />
              <ResultAndCount
                label="Follow -UP Overdue"
                count={0}
                bgColor="rgba(from var(--Primary_Color) r g b / 0.4)"
                textColor="Primary_Color"
              />
            </div>
          </div>
          <div className={styles.totaldatacard}>
            <div className={styles.barsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search activity"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.fourfilters}>
                <button
                  className={styles.archiveBtn}
                  onClick={handleArchiveClick}
                >
                  Unassigned
                </button>
                <Dropdown
                  label="Staff"
                  options={["Online", "Referral", "Walk-in"]}
                  onChange={setSelectedStaff}
                />
                <Dropdown
                  label="Actions"
                  options={["Online", "Referral", "Walk-in"]}
                  onChange={setSelectedActions}
                />
                <button
                  className={styles.archiveBtn}
                  onClick={handleArchiveClick}
                >
                  Configure Column
                </button>
              </div>
            </div>

            <div>
              <div className={styles.dynamicdata}>
                <DynamicTable
                  headings={headingsData}
                  columnData={displayData.slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage
                  )}
                />
              </div>
              <div className={styles.paginationTable}>
                <PaginationTable
                  data={displayData}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  setCurrentPage={setCurrentPage}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
};

export default EnquiriesScreen;
